const storageUtils = {
    getToken: () => {
        return JSON.parse(localStorage.getItem('token'));
    },
    getRole: () => {
        return JSON.parse(localStorage.getItem('role'));
    }
}

export default storageUtils;